import { ExternalResourceRenderer } from '../ExternalResourceRenderer/ExternalResourceRenderer'
import cx from 'classnames'
import Styles from '../../ProseEdit.module.scss'
import { ArticleFlat } from 'types'
import { observer } from 'mobx-react-lite'
import * as Layout from 'components/Layout'
import { RightRail } from '../RightRail/RightRail'

interface Props {
  article: ArticleFlat
}

export const ExternalResourceEditor = observer(({ article }: Props) => {
  return (
    <>
      <ExternalResourceRenderer
        article={article}
        customClass={cx(Styles.rightRailExternalResource, Styles.rightRailClosed)}
      />
      <Layout.RightColumn>
        <RightRail article={article} />
      </Layout.RightColumn>
    </>
  )
})
